export default __webpack_public_path__ + "static/media/astra-isuzu.771a8a00.svg";